import { createFileRoute, redirect } from "@tanstack/react-router";

import { HomePageRoute } from "../components/home/HomePageRoute";
import { SkillsPage } from "../components/skills/SkillsPage";

/**
 * `/$org/skills` — the organization's skill leaderboard, after skills.sh: a
 * page inside Home, beside Home's sidebar (components/home/homePaths).
 */
function SkillsRouteView() {
  return (
    <HomePageRoute>
      <SkillsPage />
    </HomePageRoute>
  );
}

export const Route = createFileRoute("/$org/skills/")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: SkillsRouteView,
});
